var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var ContactsTableView = require('../contacts/contacts-table-view');
var ContactFormView = require('../contacts/contact-form');
var ContactsCollection = require('../../collections/contacts-collection');

var ContactsSelectView = require('../common/contacts-select-view');

var PersonOrganizationModalView = Marionette.View.extend({
    template: require('../../templates/persons/person-organization-modal-view.html'),

    regions: {
        organizationsSelect: '#organizations-container',
        personsSelect: '#persons-container',
        contacts: '#person-org-contacts',
        contactForm: '#person-org-contact-form',

        orgsContactList: '#orgs-contact-list',
        personsContactList: '#persons-contact-list'
    },

    ui: {
        modal: '#person-organization-modal',
        startDate: '#start-date',
        endDate: '#end-date',
        comment: '#comment',
        save: '#save',

        contactForm: '#person-org-contact-form'
    },

    events: {
        'change @ui.comment': 'onCommentChange',
        'click @ui.save': 'onSave'
    },

    childViewEvents: {
        'suggestor:selected:organization': 'organizationChanged',
        'suggestor:selected:person': 'personChanged',
        'on:contact:action': 'onContactAction',
        'on:contact:saved': 'onContactSaved',
        'contact:selected:from:contacts:list': 'onContactSelectedFromContactsList'
    },

    templateContext: function () {
        var that = this;
        var caption = that.mode == 'person' ? " Person's Organization" : " Organization's Person"
        return {
            mode: that.mode,
            caption: (that.model && that.model.get("id") ? "Edit" : "Add") + caption
        }
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.mode = options.mode;
        that.model = options.model;
        that.excludedOrgsIds = options.excludedOrgsIds || [];
        that.excludedPersonsIds = options.excludedPersonsIds || [];
        that.selectedPerson = options.selectedPerson;
        that.orgContacts = options.orgContacts;
        that.personContacts = options.personContacts;
    },

    onRender: function () {
        var that = this;

        if (this.mode == 'person')
            that.renderOrganizationSelectView(that.model.get("child"));
        if (this.mode == 'organization')
            that.renderPersonSelectView(that.selectedPerson);

        that.ui.startDate.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A',
            defaultDate: that.model.get("startTime") ? that.utils.getDateWithoutTime(new Date(that.model.get("startTime"))) : 0
        });
        that.ui.startDate.on("dp.change", function (e) {

            if (e.date) {
                that.model.set("startTime", e.date.valueOf());
            } else {
                that.model.set("startTime", 0);
            }
            that.validate();
        })/*.on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(that.model.get("startTime")) || new Date());
        })*/;

        that.ui.endDate.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A',
            defaultDate: that.model.get("endTime") ? that.utils.getDateWithoutTime(new Date(that.model.get("endTime"))) : 0
        });
        that.ui.endDate.on("dp.change", function (e) {

            if (e.date) {
                that.model.set("endTime", e.date.valueOf());
            } else {
                that.model.set("endTime", 0);
            }
            that.validate();
        })/*.on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(that.model.get("endTime")) || new Date());
        })*/;


        this.renderContacts();
        this.renderOrgContactsSelect(that.orgContacts || []);
        this.renderPersonContactsSelect(that.personContacts || []);
    },

    renderOrganizationSelectView: function (org) {
        var that = this;

        that.showChildView('organizationsSelect', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return that.excludedOrgsIds.filter(function (id) {
                        return id == item.id;
                    }).length == 0;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select Organization",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'organization',
            defaultSelected: org
        }));
    },

    renderPersonSelectView: function (person) {
        var that = this;

        that.showChildView('personsSelect', new RemoteSuggesterView({
            maxNumberOfElements: 20,
            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return that.excludedPersonsIds.filter(function (id) {
                        return id == item.id;
                    }).length == 0;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select Person",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'person',
            defaultSelected: person
        }));
    },

    renderContacts: function () {
        this.contactsView = new ContactsTableView({
            collection: new ContactsCollection(this.model.get('contacts')),
            canEdit: true,
            actionsWoConfirmation: true
        });
        this.showChildView("contacts", this.contactsView);
    },

    renderOrgContactsSelect: function (contacts) {
        this.orgContactsListView = new ContactsSelectView({
            title: "Add Contact from Organization",
            contacts: contacts,
            tag: "org"
        });
        this.showChildView("orgsContactList", this.orgContactsListView);
    },

    renderPersonContactsSelect: function (contacts) {
        this.personContactsListView = new ContactsSelectView({
            title: "Add Contact from Person",
            contacts: contacts,
            tag: "person"
        });
        this.showChildView("personsContactList", this.personContactsListView);
    },

    onCommentChange: function(event) {
        this.model.set("description", event.target.value);
    },

    onSave: function () {
        var that = this;
        console.log(this.model);
        this.model.set("child", _.omit(this.model.get("child"), "object"));
        this.model.save(this.model.toJSON(),
            {
                success: function () {
                    that.onSaved();
                    that.hide();
                },
                error: function (e) {
                    console.log(e);
                }
            });
    },

    onSaved: function () {
        this.triggerMethod("saved:person:organization");
    },

    show: function () {
        this.validate();
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    enableSave: function () {
        this.ui.save.removeAttr('disabled');
    },

    disableSave: function () {
        this.ui.save.attr('disabled', true);
    },

    validate: function () {
        if (this.model.get("parentId") && this.model.get("child") && this.model.get("child").id)
            this.enableSave();
        else
            this.disableSave();
    },

    organizationChanged: function (id) {
        if (this.model.get("child")) {
            this.model.get("child").id = id;
        }
        else
            this.model.set("child", {
                id: id,
                '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
            });

        this.validate();
        if (id) {
            var selectedOrg = this.getChildView("organizationsSelect").getSelectedSingleObject(id);
            this.renderOrgContactsSelect(((selectedOrg || {}).object || {}).contacts || []);
        }
    },

    personChanged: function (id) {
        this.model.set('parentId', id);
        this.validate();

        if (id) {
            var selectedPerson = this.getChildView("personsSelect").getSelectedSingleObject(id);
            this.renderPersonContactsSelect(((selectedPerson || {}).object || {}).contacts || []);
        }
    },

    renderContactForm: function (mode, contact) {
        this.ui.contactForm.show();
        if (mode == 'add') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                addresses: [],
                representatives: []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
        else if (mode == 'edit') {
            this.contactFormView = new ContactFormView({
                mode: mode,
                contact: contact,
                addresses: [],
                representatives: []
            });
            this.showChildView("contactForm", this.contactFormView);
        }
    },

    removeContactForm: function () {
        this.ui.contactForm.hide();
        this.detachChildView('contactForm');
    },

    onContactAction: function (data) {
        var that = this;

        if (data.mode == 'add') {
            that.renderContactForm(data.mode);
        }
        else if (data.mode == 'delete') {
            var willBeRemoveContact = data.data.attributes;
            that.model.set('contacts', (that.model.get('contacts') || []).filter(function (contact) {
                return contact.data !== willBeRemoveContact.data
                    || contact.type !== willBeRemoveContact.type
                    || contact.preferred !== willBeRemoveContact.preferred;
            }));
            that.renderContacts();

            this.orgContactsListView.showContactItem(data.data.attributes);
            this.personContactsListView.showContactItem(data.data.attributes);

        }
        else if (data.mode == 'edit') {
            var willBeEditedContact = data.data.attributes;
            var willEditContact = (that.model.get('contacts') || []).filter(function (contact) {
                return contact.data == willBeEditedContact.data
                    && contact.type == willBeEditedContact.type
                    && contact.preferred == willBeEditedContact.preferred;
            });
            this.renderContactForm(data.mode, willEditContact[0]);
        }
        else if (data.mode == 'cancel') {
            that.removeContactForm();
        } else if (data.mode == 'save') {
            var changedContact = data.data.attributes;
            (that.model.get('contacts') || []).forEach(function (contact) {
                if (contact.data == changedContact.data
                    && contact.type == changedContact.type) {
                    contact.preferred = changedContact.preferred;
                }
            });
        }
    },

    onContactSaved: function (data) {
        var that = this;
        if (data.mode == 'add') {
            that.model.set('contacts', (that.model.get('contacts') || []).filter(function (contact) {
                return contact.data !== data.contact.data
                    || contact.type !== data.contact.type
                    || contact.preferred !== data.contact.preferred;
            }));

            that.model.get('contacts').push(data.contact);
        }

        that.renderContacts();
        that.removeContactForm();
    },

    onContactSelectedFromContactsList: function (payload) {
        this.contactsView.add(payload.contact);
        this.model.get('contacts').push(payload.contact);
        if (payload.tag === 'org') {
            this.orgContactsListView.hideContactItem(payload.contact);
        } else if (payload.tag === 'person') {
            this.personContactsListView.hideContactItem(payload.contact);
        }

    }
});

module.exports = PersonOrganizationModalView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/person-organization-modal-view.js
// module id = 278
// module chunks = 0